/**
 * Return the widget config for a given widget id.
 */
function widgetConfigFromId(widgetId) {
  const normalizedWidgetId = (widgetId || '')
    .toLowerCase()
    .replace(/content-.*/, 'content')
    .replace(/(\b|-)\w/g, function(match) {
      return match.replace(/-/, '')
    })
    .replace(/^8./, '')

  let constructor = 'Widget'
  let config = {}
  let error
  const commonCustomizationOptions = {
    layout: {
      type: 'slidy',
    },
    slider: {
      normalizeArrowStyles: true,
    },
    productCard: {
      remove: {
        alternativeBadge: true,
        alternativeBadgeIcon: true,
        addToCart: true,
        variantsDropDown: true,
        variants: true,
      },
    },
    featureFlags: {
      skipTriggerProductInSlider: false,
      withAlternativesInSlider: true,
      withAlternativesBox: false,
      hideNonTriggerAlternativeBadge: true,
      withProductDetailsView: false,
    },
  }

  switch (normalizedWidgetId) {
    case 'content':
      config = {
        apiUrl: 'https://onsite.8select.io/content_v2/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setCompose',
          },
        },
        eternalId: 'content',
        type: 'Content',
      }
      break
    case 'poc':
      config = {
        apiUrl: 'https://onsite.8select.io/omniset_v2/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setCompose',
          },
        },
        eternalId: 'poc',
        type: 'Poc',
      }
      break
    case 'set':
      config = {
        apiUrl: 'https://onsite.8select.io/omniset_v2/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setCompose',
          },
        },
        eternalId: 'set',
        type: 'Set',
      }
      break
    case 'syspsv':
    case 'setcompose':
      config = {
        apiUrl: 'https://onsite.8select.io/omniset_v2/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setCompose',
          },
        },
        eternalId: 'set-compose',
        type: 'SetCompose',
      }
      break
    case 'sysacc':
    case 'setflat':
      config = {
        apiUrl: 'https://onsite.8select.io/omniset_v2/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setCompose',
          },
        },
        eternalId: 'set-flat',
        type: 'SetFlat',
      }
      break
    case 'setcustom':
      config = {
        apiUrl: 'https://onsite.8select.io/customset_v1/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setPhoto',
          },
          layout: {
            type: 'slidyWithPhoto',
          },
        },
        eternalId: 'set-custom',
        type: 'SetCustom',
      }
      break
    case 'setphoto':
      config = {
        apiUrl: 'https://onsite.8select.io/customset_v1/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'setPhoto',
          },
          layout: {
            type: 'slidyWithPhoto',
          },
        },
        eternalId: 'set-photo',
        type: 'SetPhoto',
      }
      break
    case 'similar':
      config = {
        apiUrl: 'https://onsite.8select.io/similar_v2/',
        customizationOptions: {
          ...commonCustomizationOptions,
          widget: {
            type: 'similar',
          },
        },
        eternalId: 'similar',
        type: 'Similar',
      }
      break
    case 'sysbutton':
      constructor = 'SysButton'
      config = {
        eternalId: 'teaser-button',
        type: 'SysButton',
      }
      break
    case 'syspsvbutton':
      constructor = 'SysPsvButton'
      config = {
        eternalId: 'deprecated-sys-psv-button',
        type: 'SysPsvButton',
      }
      break
    default:
      constructor = undefined
      config = undefined
      error = `Widget with id "${widgetId}" does not exist. Please check https://docs.8select.io/ for available widgets.`
  }

  return {
    constructor,
    config,
    error,
  }
}

export default widgetConfigFromId
